import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Grid, Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CommonTable from "components/commonTable/CommonTable";
import CommonFilter from "components/commonFilter/CommonFilter";
import SearchBar from "components/commonSearch/SearchBar";
import Loader from "components/loader/Loader";
import ComplianceUpload from "./ComplianceUpload";
import CommonSDF from "components/commonSDF/CommonSDF";

function ComplianceTab(props) {
  const {
    value,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage,
  } = props;

  const [showTabs, setShowTabs] = useState(true); // State to control the visibility of the tabs

  const role = localStorage.getItem("role");
  const location = useLocation();

  useEffect(() => {
    // Check if the "upload" query parameter exists in the URL
    const params = new URLSearchParams(location.search);
    const uploadParam = params.get("upload");

    if (uploadParam === "true") {
      // If the "upload" query parameter is set to true, hide the tab section
      setShowTabs(false);
    } else {
      setShowTabs(true);
    }
  }, [location.search]);

  const handleChange = (event, newValue) => {
    props?.handleChange(newValue);
  };

  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle">
          {showTabs && ( // Conditionally render the tabs section based on the showTabs state
            <TabContext value={value}>
              <Grid
                container
                className="tabBoxStyle"
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <TabList
                    className="minHeight32"
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    TabIndicatorProps={{
                      style: { backgroundColor: "white" }, // Replace 'none' with your desired color
                    }}
                  >
                    {!props?.accessForOnlyViewSubVendor && (
                      <Tab label="Sub-Vendor" value="2" className="tabStyle" />
                    )}
                    {!props?.accessForOnlyViewDriver && (
                      <Tab label="Driver" value="3" className="tabStyle" />
                    )}
                    {!props?.accessForOnlyViewVehicle && (
                      <Tab label="Vehicle" value="4" className="tabStyle" />
                    )}
                  </TabList>
                </Grid>
                {value !== "5" && (
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                    }}
                  >
                    <CommonSDF
                      {...props}
                      onSearchQuery={props?.onSearch}
                      search={props?.search}
                      // Search={'true'}
                      filter={"true"}
                      tabName={"company"}
                      defaultStatus={props.defaultStatus}
                      filterdata={props?.filterdata}
                      onFilterChange={props?.onFilterChange}
                      onRestFilter={props?.onRestFilter}
                    />
                  </Box>
                )}
              </Grid>
              <TabPanel value="2" className="vendotTable tabPanelStyle">
                {props?.loader ? (
                  <Loader />
                ) : (
                  <CommonTable
                    data={props?.tableData}
                    tableOnClickRow={props?.onClickTableVendor}
                    handleChangePage={props?.handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    isClickable={true}
                  />
                )}
              </TabPanel>
              <TabPanel value="3" className="vendotTable tabPanelStyle">
                {props?.loader ? (
                  <Loader />
                ) : (
                  <CommonTable
                    data={props?.tableData}
                    tableOnClickRow={props?.onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={true}
                  />
                )}
              </TabPanel>
              <TabPanel value="4" className="vendotTable tabPanelStyle">
                {props?.loader ? (
                  <Loader />
                ) : (
                  <CommonTable
                    data={props?.tableData}
                    tableOnClickRow={props?.onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={true}
                  />
                )}
              </TabPanel>
              <TabPanel value="5" className="tabPanelStyle">
                <ComplianceUpload tabName={"Self"} />
              </TabPanel>
            </TabContext>
          )}
          {!showTabs && <ComplianceUpload />}
        </Box>
      </Grid>
    </Grid>
  );
}

export default ComplianceTab;
